import { c as _c } from "react/compiler-runtime";
import { addDays, differenceInHours } from 'date-fns';
import { useContext } from 'react';
import useSWR from 'swr';
import { APIList } from '../../../../../../../typings/API.interface';
import { Event, EventWithData } from '../../../../../../../typings/Event.interface';
import { EventAttempt } from '../../../../../../../typings/EventAttempt.interface';
import { APIWebhook } from '../../../../../../../typings/Webhook.interface';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import { formatDate } from '../../../../utils/date';
import { getErrorCodeLabels } from '../../../../utils/error-codes';
import Alert from '../../../common/base/Alert';
import Badge from '../../../common/base/Badge';
import Divider from '../../../common/base/Divider';
import Chip from '../../../common/base/Chip';
import Link from '../../../common/base/Link';
import Text from '../../../common/base/Text';
import CopyableText from '../../../common/CopyableText';
import { Div } from '../../../common/helpers/StyledUtils';
import { StyledViewSplitPaneContent, StyledViewSplitPaneLayout, StyledViewSplitPaneSidebar, StyledViewSplitPaneSidebarBody, ViewMetadataCopyable, ViewMetadataDate, ViewMetadataItem, ViewSplitPaneContentHeader, ViewSplitPaneSidebarHeader } from '../../../layouts/ViewLayout';
import { MetadataGrid } from '../../../common/MetadataGrid';
import { Status } from '../../../common/Status';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { DashboardContext } from '../DashboardContext';
import { EventHTTPRequest } from './EventHTTPRequest';
import Loading from '../../../common/base/Loading';
import { useDatePreferences } from '../../../hooks/useDatePreferences';
export const EventMetadata = t0 => {
  const $ = _c(159);
  const {
    embedded: t1,
    event,
    webhook,
    attempts,
    onAttemptSelected
  } = t0;
  const embedded = t1 === undefined ? false : t1;
  const {
    timezone
  } = useDatePreferences();
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  let t2;
  if ($[0] !== event.cli_id) {
    t2 = event.cli_id && APIMethodKeys.cli_clients.list({
      id: event.cli_id
    });
    $[0] = event.cli_id;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== HookdeckAPI.cli_clients || $[3] !== event.cli_id) {
    t3 = () => HookdeckAPI.cli_clients.list({
      id: event.cli_id
    });
    $[2] = HookdeckAPI.cli_clients;
    $[3] = event.cli_id;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: cli_clients
  } = useSWR(t2, t3);
  const t4 = embedded ? 1 : "120px 1fr";
  const t5 = embedded ? 0 : 3;
  let t6;
  if ($[5] !== t4 || $[6] !== t5) {
    t6 = {
      columns: t4,
      gap: t5,
      gap_x: 6
    };
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const grid = t6;
  const t7 = embedded ? 1 : 2;
  const t8 = embedded ? 0 : 3;
  let t9;
  if ($[8] !== t7 || $[9] !== t8) {
    t9 = {
      columns: t7,
      gap: t8
    };
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Text muted={true} ellipsis={true}>Status</Text>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== event) {
    t11 = <Status show_response={false} {...event} />;
    $[12] = event;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== embedded || $[15] !== grid || $[16] !== t11) {
    t12 = <MetadataGrid embedded={embedded} grid={grid}>{t10}{t11}</MetadataGrid>;
    $[14] = embedded;
    $[15] = grid;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== embedded) {
    t13 = embedded && <Divider />;
    $[18] = embedded;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Text muted={true} ellipsis={true}>Latest attempt</Text>;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== attempts || $[22] !== onAttemptSelected) {
    t15 = !attempts || attempts?.count === 0 ? <Text mono={true} muted={true}>–</Text> : <Chip outline={true} mono={true} label={attempts.models[0].id} onClick={() => onAttemptSelected(attempts.models[0].id)} />;
    $[21] = attempts;
    $[22] = onAttemptSelected;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== embedded || $[25] !== grid || $[26] !== t15) {
    t16 = <MetadataGrid embedded={embedded} grid={grid}>{t14}{t15}</MetadataGrid>;
    $[24] = embedded;
    $[25] = grid;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== embedded) {
    t17 = embedded && <Divider />;
    $[28] = embedded;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Text muted={true} ellipsis={true}>Event ID</Text>;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== event.id) {
    t19 = <CopyableText value={event.id} mono={true} />;
    $[31] = event.id;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== embedded || $[34] !== grid || $[35] !== t19) {
    t20 = <MetadataGrid embedded={embedded} grid={grid}>{t18}{t19}</MetadataGrid>;
    $[33] = embedded;
    $[34] = grid;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== embedded) {
    t21 = embedded && <Divider />;
    $[37] = embedded;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Text muted={true} ellipsis={true}>Latest attempt at</Text>;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  const t23 = !!event.last_attempt_at;
  const t24 = !event.last_attempt_at;
  let t25;
  if ($[40] !== event.last_attempt_at || $[41] !== timezone) {
    t25 = event.last_attempt_at ? formatDate(event.last_attempt_at, "MMM d HH:mm:ss", timezone).toUpperCase() : "\u2013";
    $[40] = event.last_attempt_at;
    $[41] = timezone;
    $[42] = t25;
  } else {
    t25 = $[42];
  }
  let t26;
  if ($[43] !== t23 || $[44] !== t24 || $[45] !== t25) {
    t26 = <Text mono={t23} ellipsis={true} muted={t24}>{t25}</Text>;
    $[43] = t23;
    $[44] = t24;
    $[45] = t25;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  let t27;
  if ($[47] !== embedded || $[48] !== grid || $[49] !== t26) {
    t27 = <MetadataGrid embedded={embedded} grid={grid}>{t22}{t26}</MetadataGrid>;
    $[47] = embedded;
    $[48] = grid;
    $[49] = t26;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  let t28;
  if ($[51] !== embedded) {
    t28 = embedded && <Divider />;
    $[51] = embedded;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  let t29;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <Text muted={true} ellipsis={true}>Latest response</Text>;
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] !== event.error_code || $[55] !== event.response_status) {
    t30 = event.response_status || event.error_code ? <Div flex={{
      align: "center",
      gap: 1
    }}>{event.response_status && <Badge mono={true} success={event.response_status < 300} danger={event.response_status >= 300} subtle={true}>{event.response_status}</Badge>}{event.error_code && <Badge mono={true} danger={true} subtle={true}>{event.error_code}</Badge>}</Div> : <Text mono={true} muted={true}>–</Text>;
    $[54] = event.error_code;
    $[55] = event.response_status;
    $[56] = t30;
  } else {
    t30 = $[56];
  }
  let t31;
  if ($[57] !== embedded || $[58] !== grid || $[59] !== t30) {
    t31 = <MetadataGrid embedded={embedded} grid={grid}>{t29}{t30}</MetadataGrid>;
    $[57] = embedded;
    $[58] = grid;
    $[59] = t30;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== embedded) {
    t32 = embedded && <Divider />;
    $[61] = embedded;
    $[62] = t32;
  } else {
    t32 = $[62];
  }
  let t33;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <Text muted={true} ellipsis={true}>Next Scheduled Attempt</Text>;
    $[63] = t33;
  } else {
    t33 = $[63];
  }
  const t34 = !event.next_attempt_at;
  let t35;
  if ($[64] !== event.next_attempt_at || $[65] !== timezone) {
    t35 = event.next_attempt_at ? formatDate(event.next_attempt_at, "MMM d HH:mm:ss", timezone).toUpperCase() : "\u2013";
    $[64] = event.next_attempt_at;
    $[65] = timezone;
    $[66] = t35;
  } else {
    t35 = $[66];
  }
  let t36;
  if ($[67] !== t34 || $[68] !== t35) {
    t36 = <Text mono={true} ellipsis={true} muted={t34}>{t35}</Text>;
    $[67] = t34;
    $[68] = t35;
    $[69] = t36;
  } else {
    t36 = $[69];
  }
  let t37;
  if ($[70] !== embedded || $[71] !== grid || $[72] !== t36) {
    t37 = <MetadataGrid embedded={embedded} grid={grid}>{t33}{t36}</MetadataGrid>;
    $[70] = embedded;
    $[71] = grid;
    $[72] = t36;
    $[73] = t37;
  } else {
    t37 = $[73];
  }
  let t38;
  if ($[74] !== embedded) {
    t38 = embedded && <Divider />;
    $[74] = embedded;
    $[75] = t38;
  } else {
    t38 = $[75];
  }
  let t39;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <Text muted={true} ellipsis={true}>Created at</Text>;
    $[76] = t39;
  } else {
    t39 = $[76];
  }
  let t40;
  if ($[77] !== event.created_at || $[78] !== timezone) {
    t40 = formatDate(event.created_at, "MMM d HH:mm:ss", timezone).toUpperCase();
    $[77] = event.created_at;
    $[78] = timezone;
    $[79] = t40;
  } else {
    t40 = $[79];
  }
  let t41;
  if ($[80] !== t40) {
    t41 = <Text mono={true} ellipsis={true}>{t40}</Text>;
    $[80] = t40;
    $[81] = t41;
  } else {
    t41 = $[81];
  }
  let t42;
  if ($[82] !== embedded || $[83] !== grid || $[84] !== t41) {
    t42 = <MetadataGrid embedded={embedded} grid={grid}>{t39}{t41}</MetadataGrid>;
    $[82] = embedded;
    $[83] = grid;
    $[84] = t41;
    $[85] = t42;
  } else {
    t42 = $[85];
  }
  let t43;
  if ($[86] !== embedded) {
    t43 = embedded && <Divider />;
    $[86] = embedded;
    $[87] = t43;
  } else {
    t43 = $[87];
  }
  let t44;
  if ($[88] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <Text muted={true}>Connection</Text>;
    $[88] = t44;
  } else {
    t44 = $[88];
  }
  let t45;
  if ($[89] !== webhook) {
    t45 = webhook ? <Chip outline={true} mono={true} label={webhook.full_name} to={`/connections/${webhook.id}`} /> : <Text muted={true}>Deleted</Text>;
    $[89] = webhook;
    $[90] = t45;
  } else {
    t45 = $[90];
  }
  let t46;
  if ($[91] !== embedded || $[92] !== grid || $[93] !== t45) {
    t46 = <MetadataGrid embedded={embedded} grid={grid}>{t44}{t45}</MetadataGrid>;
    $[91] = embedded;
    $[92] = grid;
    $[93] = t45;
    $[94] = t46;
  } else {
    t46 = $[94];
  }
  let t47;
  if ($[95] !== embedded) {
    t47 = embedded && <Divider />;
    $[95] = embedded;
    $[96] = t47;
  } else {
    t47 = $[96];
  }
  let t48;
  if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = <Text muted={true} ellipsis={true}>Successful at</Text>;
    $[97] = t48;
  } else {
    t48 = $[97];
  }
  const t49 = !event.successful_at;
  let t50;
  if ($[98] !== event.successful_at || $[99] !== timezone) {
    t50 = event.successful_at ? formatDate(event.successful_at, "MMM d HH:mm:ss", timezone).toUpperCase() : "\u2013";
    $[98] = event.successful_at;
    $[99] = timezone;
    $[100] = t50;
  } else {
    t50 = $[100];
  }
  let t51;
  if ($[101] !== t49 || $[102] !== t50) {
    t51 = <Text mono={true} ellipsis={true} muted={t49}>{t50}</Text>;
    $[101] = t49;
    $[102] = t50;
    $[103] = t51;
  } else {
    t51 = $[103];
  }
  let t52;
  if ($[104] !== embedded || $[105] !== grid || $[106] !== t51) {
    t52 = <MetadataGrid embedded={embedded} grid={grid}>{t48}{t51}</MetadataGrid>;
    $[104] = embedded;
    $[105] = grid;
    $[106] = t51;
    $[107] = t52;
  } else {
    t52 = $[107];
  }
  let t53;
  if ($[108] !== embedded) {
    t53 = embedded && <Divider />;
    $[108] = embedded;
    $[109] = t53;
  } else {
    t53 = $[109];
  }
  let t54;
  if ($[110] === Symbol.for("react.memo_cache_sentinel")) {
    t54 = <Text muted={true} ellipsis={true}>Request</Text>;
    $[110] = t54;
  } else {
    t54 = $[110];
  }
  const t55 = `/requests/${event.request_id}`;
  let t56;
  if ($[111] !== event.request_id || $[112] !== t55) {
    t56 = <Chip outline={true} mono={true} label={event.request_id} to={t55} />;
    $[111] = event.request_id;
    $[112] = t55;
    $[113] = t56;
  } else {
    t56 = $[113];
  }
  let t57;
  if ($[114] !== embedded || $[115] !== grid || $[116] !== t56) {
    t57 = <MetadataGrid embedded={embedded} grid={grid}>{t54}{t56}</MetadataGrid>;
    $[114] = embedded;
    $[115] = grid;
    $[116] = t56;
    $[117] = t57;
  } else {
    t57 = $[117];
  }
  let t58;
  if ($[118] !== embedded) {
    t58 = embedded && <Divider />;
    $[118] = embedded;
    $[119] = t58;
  } else {
    t58 = $[119];
  }
  let t59;
  if ($[120] === Symbol.for("react.memo_cache_sentinel")) {
    t59 = <Text muted={true} ellipsis={true}>Delivery attempts</Text>;
    $[120] = t59;
  } else {
    t59 = $[120];
  }
  const t60 = `/events/${event.id}/attempts`;
  let t61;
  if ($[121] !== event.attempts || $[122] !== t60) {
    t61 = <Link icon="link" to={t60}>{event.attempts}</Link>;
    $[121] = event.attempts;
    $[122] = t60;
    $[123] = t61;
  } else {
    t61 = $[123];
  }
  let t62;
  if ($[124] !== embedded || $[125] !== grid || $[126] !== t61) {
    t62 = <MetadataGrid embedded={embedded} grid={grid}>{t59}{t61}</MetadataGrid>;
    $[124] = embedded;
    $[125] = grid;
    $[126] = t61;
    $[127] = t62;
  } else {
    t62 = $[127];
  }
  let t63;
  if ($[128] !== embedded) {
    t63 = embedded && <Divider />;
    $[128] = embedded;
    $[129] = t63;
  } else {
    t63 = $[129];
  }
  let t64;
  if ($[130] !== cli_clients?.models[0]?.device_name || $[131] !== embedded || $[132] !== grid) {
    t64 = cli_clients?.models[0]?.device_name && <><MetadataGrid embedded={embedded} grid={grid}><Text muted={true} ellipsis={true}>CLI client</Text><Text>{cli_clients?.models[0]?.device_name}</Text></MetadataGrid>{embedded && <Divider />}</>;
    $[130] = cli_clients?.models[0]?.device_name;
    $[131] = embedded;
    $[132] = grid;
    $[133] = t64;
  } else {
    t64 = $[133];
  }
  let t65;
  if ($[134] !== t12 || $[135] !== t13 || $[136] !== t16 || $[137] !== t17 || $[138] !== t20 || $[139] !== t21 || $[140] !== t27 || $[141] !== t28 || $[142] !== t31 || $[143] !== t32 || $[144] !== t37 || $[145] !== t38 || $[146] !== t42 || $[147] !== t43 || $[148] !== t46 || $[149] !== t47 || $[150] !== t52 || $[151] !== t53 || $[152] !== t57 || $[153] !== t58 || $[154] !== t62 || $[155] !== t63 || $[156] !== t64 || $[157] !== t9) {
    t65 = <Div grid={t9}>{t12}{t13}{t16}{t17}{t20}{t21}{t27}{t28}{t31}{t32}{t37}{t38}{t42}{t43}{t46}{t47}{t52}{t53}{t57}{t58}{t62}{t63}{t64}</Div>;
    $[134] = t12;
    $[135] = t13;
    $[136] = t16;
    $[137] = t17;
    $[138] = t20;
    $[139] = t21;
    $[140] = t27;
    $[141] = t28;
    $[142] = t31;
    $[143] = t32;
    $[144] = t37;
    $[145] = t38;
    $[146] = t42;
    $[147] = t43;
    $[148] = t46;
    $[149] = t47;
    $[150] = t52;
    $[151] = t53;
    $[152] = t57;
    $[153] = t58;
    $[154] = t62;
    $[155] = t63;
    $[156] = t64;
    $[157] = t9;
    $[158] = t65;
  } else {
    t65 = $[158];
  }
  return t65;
};
export const EventOverview = t0 => {
  const $ = _c(76);
  const {
    event,
    attempts,
    onAttemptSelected
  } = t0;
  const {
    timezone
  } = useDatePreferences();
  const {
    subscription,
    is_degraded_banner_active
  } = useContext(DashboardContext);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  let t1;
  if ($[0] !== event.webhook_id) {
    t1 = APIMethodKeys.webhooks.get(event.webhook_id);
    $[0] = event.webhook_id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== HookdeckAPI.webhooks || $[3] !== event.webhook_id) {
    t2 = () => HookdeckAPI.webhooks.get(event.webhook_id);
    $[2] = HookdeckAPI.webhooks;
    $[3] = event.webhook_id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      shouldRetryOnError: _temp
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    error: webhook_error,
    data: webhook
  } = useSWR(t1, t2, t3);
  let t4;
  if ($[6] !== event.cli_id) {
    t4 = event.cli_id && APIMethodKeys.cli_clients.list({
      id: event.cli_id
    });
    $[6] = event.cli_id;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== HookdeckAPI.cli_clients || $[9] !== event.cli_id) {
    t5 = () => HookdeckAPI.cli_clients.list({
      id: event.cli_id
    });
    $[8] = HookdeckAPI.cli_clients;
    $[9] = event.cli_id;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const {
    data: cli_clients
  } = useSWR(t4, t5);
  const webhook_deleted = webhook_error?.status === 410;
  let t6;
  if ($[11] !== event.created_at || $[12] !== subscription.retention_days) {
    const archived_at = addDays(new Date(event.created_at), subscription.retention_days);
    t6 = differenceInHours(archived_at, new Date());
    $[11] = event.created_at;
    $[12] = subscription.retention_days;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const hours_before_archive = t6;
  if (!webhook && !webhook_deleted) {
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = {
        grow: true,
        align: "center",
        justify: "center"
      };
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    let t8;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <Div flex={t7} w={100}><Loading /></Div>;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    return t8;
  }
  const cli_client_name = cli_clients?.models[0]?.device_name;
  const latest_attempt = attempts && attempts.count > 0 ? attempts.models[0] : null;
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ViewSplitPaneSidebarHeader title="Event details" />;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== event.error_code) {
    t8 = event.error_code && <Alert inline={true} danger={true}>{getErrorCodeLabels()[event.error_code]}</Alert>;
    $[17] = event.error_code;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== hours_before_archive) {
    t9 = hours_before_archive <= 24 && hours_before_archive >= 0 && <Alert info={true} inline={true} action={{
      label: "Upgrade",
      to: "/settings/organization/plans?highlight=retention_days",
      icon: "upgrade"
    }}>This event will be archived in{" "}{hours_before_archive === 0 ? "less then an hour" : `${hours_before_archive} hours`}.</Alert>;
    $[19] = hours_before_archive;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== event) {
    t10 = <ViewMetadataItem label="Status"><Status show_response={false} {...event} /></ViewMetadataItem>;
    $[21] = event;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== event.id) {
    t11 = <ViewMetadataItem label="Event ID"><ViewMetadataCopyable value={event.id} /></ViewMetadataItem>;
    $[23] = event.id;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== webhook || $[26] !== webhook_deleted) {
    t12 = <ViewMetadataItem label="Connection">{!webhook_deleted && webhook ? <Chip outline={true} mono={true} label={webhook.full_name} to={`/connections/${webhook.id}`} /> : <Text muted={true}>Deleted</Text>}</ViewMetadataItem>;
    $[25] = webhook;
    $[26] = webhook_deleted;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const t13 = `/requests/${event.request_id}`;
  let t14;
  if ($[28] !== event.request_id || $[29] !== t13) {
    t14 = <ViewMetadataItem label="Request"><Chip outline={true} mono={true} label={event.request_id} to={t13} /></ViewMetadataItem>;
    $[28] = event.request_id;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== cli_client_name) {
    t15 = cli_client_name && <ViewMetadataItem label="CLI client"><Text>{cli_client_name}</Text></ViewMetadataItem>;
    $[31] = cli_client_name;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== latest_attempt || $[34] !== onAttemptSelected) {
    t16 = <ViewMetadataItem label="Latest attempt">{latest_attempt ? <Chip outline={true} mono={true} label={latest_attempt.id} onClick={() => onAttemptSelected(latest_attempt.id)} /> : <Text mono={true} muted={true}>–</Text>}</ViewMetadataItem>;
    $[33] = latest_attempt;
    $[34] = onAttemptSelected;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  const t17 = !!event.last_attempt_at;
  const t18 = !event.last_attempt_at;
  let t19;
  if ($[36] !== event.last_attempt_at || $[37] !== timezone) {
    t19 = event.last_attempt_at ? formatDate(event.last_attempt_at, "MMM d HH:mm:ss", timezone).toUpperCase() : "\u2013";
    $[36] = event.last_attempt_at;
    $[37] = timezone;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t17 || $[40] !== t18 || $[41] !== t19) {
    t20 = <ViewMetadataItem label="Latest attempt at"><Text mono={t17} ellipsis={true} muted={t18}>{t19}</Text></ViewMetadataItem>;
    $[39] = t17;
    $[40] = t18;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== event.error_code || $[44] !== event.response_status) {
    t21 = <ViewMetadataItem label="Latest response">{event.response_status || event.error_code ? <Div flex={{
        align: "center",
        gap: 1
      }}>{event.response_status && <Badge mono={true} success={event.response_status < 300} danger={event.response_status >= 300} subtle={true}>{event.response_status}</Badge>}{event.error_code && <Badge mono={true} danger={true} subtle={true}>{event.error_code}</Badge>}</Div> : <Text mono={true} muted={true}>–</Text>}</ViewMetadataItem>;
    $[43] = event.error_code;
    $[44] = event.response_status;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== event.next_attempt_at || $[47] !== timezone) {
    t22 = event.next_attempt_at && <ViewMetadataItem label="Next scheduled attempt"><Text mono={true} ellipsis={true}>{formatDate(event.next_attempt_at, "MMM d HH:mm:ss", timezone).toUpperCase()}</Text></ViewMetadataItem>;
    $[46] = event.next_attempt_at;
    $[47] = timezone;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== event.successful_at || $[50] !== timezone) {
    t23 = event.successful_at && <ViewMetadataItem label="Successful at"><Text mono={true} ellipsis={true}>{formatDate(event.successful_at, "MMM d HH:mm:ss", timezone).toUpperCase()}</Text></ViewMetadataItem>;
    $[49] = event.successful_at;
    $[50] = timezone;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== event.created_at) {
    t24 = <ViewMetadataItem label="Created at"><ViewMetadataDate date={event.created_at} /></ViewMetadataItem>;
    $[52] = event.created_at;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== t10 || $[55] !== t11 || $[56] !== t12 || $[57] !== t14 || $[58] !== t15 || $[59] !== t16 || $[60] !== t20 || $[61] !== t21 || $[62] !== t22 || $[63] !== t23 || $[64] !== t24 || $[65] !== t8 || $[66] !== t9) {
    t25 = <StyledViewSplitPaneSidebar><StyledViewSplitPaneSidebarBody>{t7}{t8}{t9}{t10}{t11}{t12}{t14}{t15}{t16}{t20}{t21}{t22}{t23}{t24}</StyledViewSplitPaneSidebarBody></StyledViewSplitPaneSidebar>;
    $[54] = t10;
    $[55] = t11;
    $[56] = t12;
    $[57] = t14;
    $[58] = t15;
    $[59] = t16;
    $[60] = t20;
    $[61] = t21;
    $[62] = t22;
    $[63] = t23;
    $[64] = t24;
    $[65] = t8;
    $[66] = t9;
    $[67] = t25;
  } else {
    t25 = $[67];
  }
  let t26;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <ViewSplitPaneContentHeader title="Request data" />;
    $[68] = t26;
  } else {
    t26 = $[68];
  }
  let t27;
  if ($[69] !== event || $[70] !== subscription.retention_days) {
    t27 = <StyledViewSplitPaneContent>{t26}{event.data ? <EventHTTPRequest event={event} hide_title={true} /> : <Text muted={true} as="p">The data associated with this event has been archived, since this event occurred prior to your {subscription.retention_days}-day archival period.</Text>}</StyledViewSplitPaneContent>;
    $[69] = event;
    $[70] = subscription.retention_days;
    $[71] = t27;
  } else {
    t27 = $[71];
  }
  let t28;
  if ($[72] !== is_degraded_banner_active || $[73] !== t25 || $[74] !== t27) {
    t28 = <StyledViewSplitPaneLayout banner_active={is_degraded_banner_active}>{t25}{t27}</StyledViewSplitPaneLayout>;
    $[72] = is_degraded_banner_active;
    $[73] = t25;
    $[74] = t27;
    $[75] = t28;
  } else {
    t28 = $[75];
  }
  return t28;
};
function _temp(error) {
  return error.status !== 410;
}